import { render, staticRenderFns } from "./AdsBanner.vue?vue&type=template&id=c31f548e&scoped=true"
import script from "./AdsBanner.vue?vue&type=script&lang=js"
export * from "./AdsBanner.vue?vue&type=script&lang=js"
import style0 from "./AdsBanner.vue?vue&type=style&index=0&id=c31f548e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c31f548e",
  null
  
)

export default component.exports